import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoggedInGuard } from "./guards/logged-in.guard";
import { NotFoundComponent } from "./not-found/not-found/not-found.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "admin",
    pathMatch: "full",
  },
  {
    path: "auth",
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "admin",
    loadChildren: () =>
      import("./admin/admin.module").then((m) => m.AdminModule),
    canActivate: [LoggedInGuard],
  },
  {
    path: "reports",
    loadChildren: () =>
      import("./reports/reports.module").then((m) => m.ReportsModule),
    canActivate: [LoggedInGuard],
  },
  {
    path: "sudo",
    loadChildren: () => import("./sudo/sudo.module").then((m) => m.SudoModule),
    canActivate: [LoggedInGuard],
  },
  {
    path: "not-found",
    loadComponent: () =>
      import("./not-found/not-found/not-found.component").then(
        (m) => m.NotFoundComponent
      ),
  },
  {
    path: "site-in-maintenance",
    loadComponent: () =>
      import("./site-in-maintenance/site-in-maintenance.component").then(
        (m) => m.SiteInMaintenanceComponent
      ),
  },
  { path: "**", component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "top" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
